{
  "name": "@uppy/audio",
  "description": "Uppy plugin that records audio using the device’s microphone.",
  "version": "2.2.2",
  "license": "MIT",
  "main": "lib/index.js",
  "style": "dist/style.min.css",
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "audio",
    "microphone",
    "sound",
    "record",
    "mediarecorder"
  ],
  "type": "module",
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "dependencies": {
    "@uppy/utils": "workspace:^",
    "preact": "^10.5.13"
  },
  "devDependencies": {
    "cssnano": "^7.0.7",
    "jsdom": "^26.1.0",
    "postcss": "^8.5.6",
    "postcss-cli": "^11.0.1",
    "sass": "^1.89.2",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "build:css": "sass --load-path=../../ src/style.scss dist/style.css && postcss dist/style.css -u cssnano -o dist/style.min.css",
    "typecheck": "tsc --build",
    "test": "vitest run --environment=jsdom --silent='passed-only'"
  }
}
